// Guests (anonymous Firebase users) get a few free exams; after that they must sign in.
// ponytail: counted per browser in localStorage; a determined user can clear it. Move to Firestore if that matters.
export const GUEST_EXAM_LIMIT = 3;

const KEY = 'guestExamsTaken';
const LEGACY_KEY = 'guestExamUsed'; // the old one-free-exam flag: '1' counts as one exam taken

export const guestExamsTaken = () => {
  try {
    const legacy = localStorage.getItem(LEGACY_KEY) === '1' ? 1 : 0;
    return Math.max(Number(localStorage.getItem(KEY)) || 0, legacy);
  } catch { return 0; }
};

export const guestExamsLeft = () => Math.max(0, GUEST_EXAM_LIMIT - guestExamsTaken());

export const recordGuestExam = () => {
  try { localStorage.setItem(KEY, String(guestExamsTaken() + 1)); } catch { /* storage blocked: nothing to persist */ }
};

// A signed-out account holder doesn't get another round of free guest exams
export const exhaustGuestExams = () => {
  try { localStorage.setItem(KEY, String(GUEST_EXAM_LIMIT)); } catch { /* storage blocked */ }
};
